import { useRef, useState } from 'react';
import { FormApi } from 'informed';
import api from 'api';
import { useDispatch, useReduxState } from 'hooks';
import { actions } from 'store';
import { Button } from 'components/common';
import { Form, FormGroup, Text } from 'components/common/form';
import {
  Modal,
  ModalContent,
  ModalFooter,
  ModalPortal
} from 'components/common/modal';

const UserNameForm = ({
  useForCertificateOnly = false
}: {
  useForCertificateOnly?: boolean;
}) => {
  const [loading, setLoading] = useState(false);

  const apiRef = useRef<FormApi>(undefined);

  const { messages, user } = useReduxState();
  const { dispatch } = useDispatch();

  const submit = async (values) => {
    try {
      setLoading(true);
      await api.post(`/auth/profile`, values);
      setLoading(false);
      dispatch(
        actions.setUser({
          ...user,
          ...values
        })
      );
      dispatch(
        actions.addNotice({
          text: messages.commonSavedSuccessfully,
          type: 'success'
        })
      );
    } catch (err) {
      setLoading(false);
      await dispatch.handleErrorDispatch(err);
    }
  };

  const validateRequired = (value) => {
    return !value || !value.length ? messages.commonFieldRequired : undefined;
  };

  return (
    <ModalPortal>
      <Form getApi={(formApi) => (apiRef.current = formApi)} onSubmit={submit}>
        {({ formState }) => (
          <Modal
            title={
              useForCertificateOnly
                ? messages.usersNameInCertificate
                : messages.profileInformation
            }
            visible={true}
            width="medium"
          >
            <ModalContent>
              {useForCertificateOnly ? (
                <>
                  <p className="description">
                    {messages.usersNameInCertificateInfo}
                  </p>
                  <p className="description">
                    {messages.usersNameInCertificateUsage}
                  </p>
                </>
              ) : (
                <p className="description">
                  {messages.usersFillYourProfileInformation}
                </p>
              )}

              <div className="row-sm">
                <div className="col-1of2">
                  <FormGroup
                    htmlFor="first-name"
                    label={messages.usersFirstName}
                  >
                    <Text
                      error={formState.errors.firstName}
                      field="firstName"
                      id="first-name"
                      validate={validateRequired}
                      validateOnChange={true}
                    />
                  </FormGroup>
                </div>
                <div className="col-1of2">
                  <FormGroup htmlFor="last-name" label={messages.usersLastName}>
                    <Text
                      error={formState.errors.lastName}
                      field="lastName"
                      id="last-name"
                      validate={validateRequired}
                      validateOnChange={true}
                    />
                  </FormGroup>
                </div>
              </div>
            </ModalContent>

            <ModalFooter>
              <Button
                category="success"
                loading={loading}
                text={messages.commonSave}
                type="submit"
              />
            </ModalFooter>
          </Modal>
        )}
      </Form>

      <style jsx>{`
        .description {
          font-size: 1.6rem;
          font-weight: 400;
          margin: 0 0 15px;
        }
      `}</style>
    </ModalPortal>
  );
};

export default UserNameForm;
